import { PlusIcon, SparkleIcon, PrecraftedIcon, UploadIcon } from "./icons";

/* Create entry points — existing, working routes. The generic "New Game" action
   lands on the chooser; Blank / AI are explicit shortcuts. */
export const CREATE_CHOOSER = "/create";
export const CREATE_BLANK = "/create/manual";
export const CREATE_AI = "/create/ai";

/**
 * Single source of truth for the create entry points, so the header "New Game"
 * menu, the sidebar Create section, and the New-game grid tile all render the
 * same icons + labels. `Icon` is the component (consumers size it); `route` is
 * set for live entries, `soon` holds the tooltip copy for placeholders (§10).
 */
export const CREATE_ENTRIES = [
  { key: "blank", label: "Blank", Icon: PlusIcon, route: CREATE_BLANK },
  { key: "ai", label: "AI generate", Icon: SparkleIcon, route: CREATE_AI },
  {
    key: "precrafted",
    label: "Pre-crafted",
    Icon: PrecraftedIcon,
    soon: "Browse pre-crafted games — coming soon",
  },
  {
    key: "csv",
    label: "Import CSV",
    Icon: UploadIcon,
    soon: "Import games from CSV — coming soon",
  },
];
